import { Skeleton } from '@mui/material';
import React from 'react';

export const SkeletonLoader = () => {
  return (
    <>
      <div className="flex flex-col py-5 justify-center gap-y-4 w-full">
        <Skeleton
          variant="rectangular"
          width={'100%'}
          height={30}
          animation="wave"
        />
        <Skeleton
          variant="rectangular"
          width={'100%'}
          height={20}
          animation="wave"
        />
        <Skeleton
          variant="rectangular"
          width={'100%'}
          height={15}
          animation="wave"
        />
      </div>
    </>
  );
};
